/**
 * Google Tag Manager initialization.
 *
 * Configured at build time via REACT_APP_GTM_CONTAINER_ID. Skips silently
 * when the var is absent so dev/non-prod environments don't pollute prod
 * analytics. Call initGtm() once from index.tsx before React renders, then
 * call trackPageView() on each hash-based route change, passing the resolved
 * page title so GA can distinguish visits (defaults to document.title).
 */

import { env } from "./env";

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

export function initGtm(): void {
  const containerId = env.REACT_APP_GTM_CONTAINER_ID;
  if (!containerId) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
  document.head.appendChild(script);

  const noscript = document.createElement("noscript");
  const iframe = document.createElement("iframe");
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${containerId}`;
  iframe.height = "0";
  iframe.width = "0";
  iframe.style.cssText = "display:none;visibility:hidden";
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
}

export function trackPageView(pagePath: string, pageTitle?: string): void {
  if (!window.dataLayer) return;
  window.dataLayer.push({
    event: "spa_pageview",
    page_path: pagePath,
    page_title: pageTitle ?? document.title,
  });
}
